export default "https://cdn-static.gokick.com/assets/9903fb7c557cf9d7d858f1d02aec0837d292f7c0/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";